import connects from './columns/connects'
import posts from './columns/posts'
import shares from './columns/shares'

const mod = {
    namespaced: true,
    modules: {
        connects: connects,
        posts: posts,
        shares: shares
    },
    state: {
        activeInteractionPost: {},
        auths: [],
        campaigns: [],
        selectedCampaignId: null,
        socialResponseModalContext: 'hidden'
    },
    mutations: {
        activeInteractionPost: (state, postDetail) => {
            state.activeInteractionPost = postDetail;
        },
        auths: (state, auths) => {
            state.auths = auths;
        },
        campaigns: (state, campaigns) => {
            state.campaigns = campaigns;
        },
        selectedCampaignId: (state, campaignId) => {
            state.selectedCampaignId = campaignId;
        },
        socialResponseModalContext: (state, socialResponseModalContext) => {
            state.socialResponseModalContext = socialResponseModalContext;
        }
    },
    actions: {
        activeInteractionPost({ commit }, postDetail) {
            commit('activeInteractionPost', postDetail);
        },
        auths({ commit }, context) {
            commit('auths', context);
        },
        campaigns({ commit }, context) {
            commit('campaigns', context);
        },
        selectedCampaignId({ commit }, campaignId) {
            commit('selectedCampaignId', campaignId);
        },
        socialResponseModalContext({ commit }, context) {
            commit('socialResponseModalContext', context);
        }
    },
    getters: {
        activeInteractionPost (state) {
            return state.activeInteractionPost;
        },
        auths(state) {
            return state.auths;
        },
        campaigns(state) {
            return state.campaigns;
        },
        selectedCampaignId(state) {
            return state.selectedCampaignId;
        },
        socialResponseModalContext(state) {
            return state.socialResponseModalContext;
        }
    }
};

export default mod;
